import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { SelectOptions } from "../select-options";

export interface IConditionOption {
  id: string;
  mainText: string;
}

export default function SelectConditionFlow({
  onSelect,
}: {
  onSelect: (selectedValue: IConditionOption) => void;
}) {
  const t = useTranslations();

  const conditionOptions: IConditionOption[] = useMemo(
    () => [
      { id: "used", mainText: t("used") },
      { id: "new", mainText: t("new") },
    ],
    [t],
  );

  // Translation is enabled so that "used"/"new" can be localized via next-intl
  return (
    <SelectOptions
      options={conditionOptions}
      onSelect={onSelect}
      hideSearch
      translation
    />
  );
}
